var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$q.platform.is.mobile
    ? _c(
        "q-layout-drawer",
        {
          attrs: { side: "left" },
          model: {
            value: _vm.showMenu,
            callback: function($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu"
          }
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "", "inset-separator": "" } },
            [
              _c("q-list-header", [_vm._v(_vm._s(_vm.$t("navigation")))]),
              _c("global-search"),
              _vm._l(_vm.getNavbarOrder, function(link, index) {
                return _c(
                  "span",
                  { key: index },
                  [
                    link.to
                      ? _c(
                          "q-item",
                          { attrs: { to: { name: link.to } } },
                          [
                            _c("q-item-side", { attrs: { icon: link.icon } }),
                            _c("q-item-main", {
                              attrs: { label: _vm.$t(link.text) }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    !link.to
                      ? _c(
                          "q-collapsible",
                          {
                            attrs: {
                              icon: "fas fa-chalkboard-teacher",
                              label: _vm.$t(link.text),
                              group: "sidebar"
                            },
                            model: {
                              value: _vm.show_merged,
                              callback: function($$v) {
                                _vm.show_merged = $$v
                              },
                              expression: "show_merged"
                            }
                          },
                          [
                            _c(
                              "q-list",
                              { attrs: { separator: "", link: "" } },
                              _vm._l(link.buttons, function(b, index) {
                                return _c(
                                  "q-item",
                                  {
                                    key: "b-" + index,
                                    attrs: { to: { name: b.to } },
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.show_merged = false
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c(
                                          "q-item-tile",
                                          { attrs: { label: "" } },
                                          [_vm._v(_vm._s(_vm.$t(b.text)))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "q-list",
            { attrs: { "no-border": "" } },
            [
              _c("q-list-header", [_vm._v(_vm._s(_vm.$t("others")))]),
              _vm.user_clients.length > 1
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "far fa-building",
                        label: _vm.getClientLabel,
                        group: "sidebar"
                      },
                      model: {
                        value: _vm.show_clients,
                        callback: function($$v) {
                          _vm.show_clients = $$v
                        },
                        expression: "show_clients"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { separator: "", link: "" } },
                        _vm._l(_vm.user_clients, function(item, index) {
                          return _c(
                            "q-item",
                            { key: index, attrs: { tag: "label" } },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-radio", {
                                    attrs: { val: item.id },
                                    model: {
                                      value: _vm.selected_client,
                                      callback: function($$v) {
                                        _vm.selected_client = $$v
                                      },
                                      expression: "selected_client"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(item.name))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.user_clients.length == 1
                ? _c(
                    "q-item",
                    [
                      _c("q-item-side", { attrs: { icon: "far fa-building" } }),
                      _c("q-item-main", {
                        attrs: { label: _vm.getClientLabel }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.countries.length > 1
                ? _c(
                    "q-collapsible",
                    {
                      attrs: {
                        icon: "fas fa-globe",
                        label: _vm.getCountryLabel,
                        group: "sidebar"
                      },
                      model: {
                        value: _vm.show_countries,
                        callback: function($$v) {
                          _vm.show_countries = $$v
                        },
                        expression: "show_countries"
                      }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { separator: "", link: "" } },
                        _vm._l(_vm.countries, function(item, index) {
                          return _c(
                            "q-item",
                            { key: index, attrs: { tag: "label" } },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-radio", {
                                    attrs: { val: item.id },
                                    model: {
                                      value: _vm.selected_country,
                                      callback: function($$v) {
                                        _vm.selected_country = $$v
                                      },
                                      expression: "selected_country"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(item.name))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.countries.length == 1
                ? _c(
                    "q-item",
                    [
                      _c("q-item-side", { attrs: { icon: "fas fa-globe" } }),
                      _c("q-item-main", {
                        attrs: { label: _vm.getCountryLabel }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showControlPanel
                ? _c(
                    "q-item",
                    { attrs: { to: { name: "admin_overview" } } },
                    [
                      _c("q-item-side", {
                        attrs: { icon: "fas fa-tachometer-alt" }
                      }),
                      _c("q-item-main", {
                        attrs: { label: _vm.$t("access_panel") }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "q-collapsible",
                {
                  attrs: {
                    icon: "far fa-user-circle",
                    label: _vm.full_name,
                    group: "sidebar"
                  }
                },
                [
                  _c(
                    "q-list",
                    { attrs: { separator: "", link: "" } },
                    [
                      _c(
                        "q-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.goToMessages()
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-icon", {
                                attrs: { name: "far fa-envelope" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(_vm.$t("messages")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.showUserProfile
                        ? _c(
                            "q-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  return _vm.goToProfile()
                                }
                              }
                            },
                            [
                              _c(
                                "q-item-side",
                                [
                                  _c("q-icon", {
                                    attrs: { name: "fas fa-cog" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(_vm.$t("edit_profile")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "q-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.showChangePassword()
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            [_c("q-icon", { attrs: { name: "fas fa-key" } })],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(_vm.$t("change_password")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-icon", {
                                attrs: { name: "fas fa-sign-out-alt" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(_vm._s(_vm.$t("sign_out")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("change-password", {
            attrs: { show_change_password: _vm.show_change_password },
            on: {
              hide_modal: function($event) {
                _vm.show_change_password = false
              }
            }
          }),
          _c("copyright")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }